import { useState } from "react";
import { useNavigate } from "react-router-dom";
import RenderTable from "./renderTable";
import TextField from "@mui/material/TextField";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { handleDelete } from "../services";
import { getAssessmentIdAPIresponse } from "../../../services";
import GenericModal from "../../../common/GenericModal";
import SpinnerButton from "../../../common/SpinnerButton";
import { SIZES } from "../../../utils/enums";
import { STATIC_STRINGS } from "../../../utils/Constants";

const RenderGrid = ({ data, setFetchOptions }: any) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const [open, setOpen] = useState("");
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleCreateAssessment = async () => {
    setLoading(true);
    const assessmentId = await getAssessmentIdAPIresponse();
    navigate(`/edit/${assessmentId}`);
  };

  const updateSelectedAssessment = (assessmentId) => {
    setOpen(assessmentId);
  };
  return (
    <div className="card">
      {/* Header  */}
      <div className="flex justify-between items-center mb-4">
        <TextField
          label={STATIC_STRINGS.ASSESSMENT_SEARCH_PLACEHOLDER}
          variant="outlined"
          size={SIZES.sm}
          className="w-1/3"
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <SpinnerButton
          className="w-56"
          onClickHandler={handleCreateAssessment}
          loading={loading}
          size={SIZES.sm}
        >
          {STATIC_STRINGS.CREATE_NEW_ASSESSMENT_TITLE}
        </SpinnerButton>
      </div>

      {/* Table Grid */}
      <RenderTable
        searchTerm={searchTerm}
        data={data}
        setFetchOptions={setFetchOptions}
        updateAssessmentId={updateSelectedAssessment}
      />

      {/* Delete Modal */}
      <GenericModal
        open={open}
        onClose={() => setOpen("")}
        loading={deleteLoading}
        onConfirm={async () => {
          setDeleteLoading(true);
          try {
            await handleDelete(open);
            setFetchOptions({
              requestId: new Date().getTime().toString(),
            });
          } catch (error) {
            console.log("DELETE API FAILED");
          }
          setOpen("");
          setDeleteLoading(false);
        }}
        title={STATIC_STRINGS.ASSESSMENT_DELETE_HEADING}
        body={STATIC_STRINGS.ASSESSMENT_DELETE_DESC}
        confirmText={STATIC_STRINGS.DELETE}
        cancelText={STATIC_STRINGS.CANCEL}
        confirmColor="error"
        Icon={DeleteOutlineIcon}
      />
    </div>
  );
};

export default RenderGrid;
